<template>
  <router-view></router-view>
</template>

<script>
    export default {
        name: "SupplierHome"
    }
</script>

<style scoped>

</style>
